import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import CustomInput from '~/components/CustomInput'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

type SubmitType = {
  name: string
  cowsNumber: string
  type: string | number | boolean | (string | number | boolean)[]
}

interface Props {
  isOpen: boolean
  handleClose: () => void
  handleSubmit: (data: SubmitType) => void
  max: number
  feedGroupNames: string[]
  type: number
}

export const feedGroupTypes = [
  {
    value: 1,
    text: 'Trockensteher'
  },
  {
    value: 2,
    text: 'Laktierende 1'
  }
]

const AddNewCowGroup: React.FC<Props> = (props) => {
  const { isOpen, handleClose, handleSubmit, type, feedGroupNames } = props
  const { t } = useTranslation()

  const [feedGroupName, setFeedGroupName] = useState('')
  const [cowsNumber, setCowsNumber] = useState('')

  useEffect(() => {
    if (isOpen) {
      setCowsNumber('')
      setFeedGroupName('')
    }
  }, [isOpen])

  function renderAddNewFeedGroupForm() {
    return <Form>
      <Form.Group widths={'equal'}>
        <Form.Field>
          <Form.Input
            label={t('Performance group name')}
            placeholder={t('Performance group name')}
            onChange={(_, data) => setFeedGroupName(data.value)}
            value={feedGroupName}
          />
          {isDuplicateNameError && <small style={{ color: 'red', fontStyle: 'italic' }}>
            {t('Performance group name already exists')}
          </small>}
        </Form.Field>
        <Form.Field>
          <CustomInput
            label={t('Number of animals')}
            value={cowsNumber}
            placeholder={t('Number of animals')}
            styleLabel={{ marginBottom: '.5rem' }}
            withLabels
            allowDecimals={false}
            min={1}
            onChange={(value) => {
              if (!value) {
                setCowsNumber('')
                return
              }
              setCowsNumber(value)
            }}
          />
          {isMaxTiereError && <small style={{ color: 'red', fontStyle: 'italic' }}>
            {t('Max number of animals: {{tiere}}', { tiere: formatNumber(props.max - 1, 0) })}
          </small>}
        </Form.Field>
      </Form.Group>
    </Form>
  }

  function getMaxTiereNumber() {
    switch (type) {
      case 1:
      case 2:
        return parseInt(cowsNumber) > props.max - 1
      default:
        return parseInt(cowsNumber) > 1000000
    }
  }

  const isMaxTiereError = getMaxTiereNumber()
  const isDuplicateNameError = feedGroupNames.some(name => name.toLowerCase() === feedGroupName.toLowerCase())
  const trimmedValueFeedGroup = feedGroupName?.toString().trim()

  return <Dialog
    textHeader={t('Add new performance group')}
    isDialogOpen={isOpen}
    minHeight={'140px'}
    noScrollingContent
    disableSubmit={(!cowsNumber || !trimmedValueFeedGroup) || isMaxTiereError || isDuplicateNameError}
    textClose={t('Cancel')}
    textSubmit={t('Add')}
    handleClose={() => handleClose()}
    textContent={renderAddNewFeedGroupForm()}
    handleSubmit={() => handleSubmit({ name: feedGroupName, cowsNumber, type: type })}
  />
}
export default AddNewCowGroup